var BrandCategory = /** @class */ (function () {
    function BrandCategory(obj, id) {
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.slug = obj.slug;
        this.position = obj.position;
        this.hidden = obj.hidden;
        this.parent_id = obj.parent_id;
        this.meta_title = obj.meta_title;
        this.meta_description = obj.meta_description;
    }
    Object.defineProperty(BrandCategory.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "ParentId", {
        get: function () {
            return this.parent_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "Hidden", {
        get: function () {
            return this.hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "MetaTitle", {
        get: function () {
            return this.meta_title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandCategory.prototype, "MetaDescription", {
        get: function () {
            return this.meta_description;
        },
        enumerable: false,
        configurable: true
    });
    return BrandCategory;
}());
export { BrandCategory };
export function createCategory(obj, id) {
    return new BrandCategory(obj, id);
}
export function createCategories(rawCategories) {
    var categories = [];
    var rawCategoriesData = rawCategories;
    for (var _i = 0, rawCategoriesData_1 = rawCategoriesData; _i < rawCategoriesData_1.length; _i++) {
        var rawCategory = rawCategoriesData_1[_i];
        var category = createCategory(rawCategory.attributes, rawCategory.id);
        categories.push(category);
    }
    return categories;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/brandCategory/brandCategory.ts
// module id = 532
// module chunks = 0